import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../../../core/services/app.service';
import { CryptoService } from '../../../core/services/crypto.service';
import { LocalStorageService } from '../../../core/services/local-storage.service';
@Injectable({
    providedIn: 'root'
})
export class CamerallaLogin {
    public dataKey = 'camerallaUser';
    authApi = AppService.getApiUrl() + '/api/customers/auth';
    digitalAuthUrl = AppService.getApiUrl() + '/api/customers/digitalAuth/login';
    constructor(private http: HttpClient,
                private localStorage: LocalStorageService,
                private cryptoService: CryptoService) {
    }

    private getLocalUserObject() {
        return this.cryptoService.decrypt(this.localStorage.getItem(this.dataKey));
    }

    private setLocalUserObject(data) {
        this.localStorage.setItem(this.dataKey, this.cryptoService.encrypt(data));
    }

    login(code) {
        const header = new HttpHeaders().append('Content-Type', 'application/json');
        const ob = JSON.stringify({code: code});

        return this.http.post(this.authApi, ob, {headers: header}).toPromise().then(
            response => {
                if (response['IsSuccess']) {
                    const userObject = response['Data']['user'];
                    const cameralla_id = userObject['id'];
                    const wp_id = userObject['wp_id'];
                    const accessToken = userObject['access_token'];

                    this.setLocalUserObject({id: cameralla_id, wp_id: wp_id, accessToken: accessToken});

                    return Promise.resolve(true);
                }

                return Promise.resolve(false);
            },
            error => {
                console.log('login error ' + error);
                return Promise.resolve(false);
            }
        );
    }

    public digitalLogin(credentials) {
        return this.http.post(this.digitalAuthUrl, credentials, {
        observe: 'response',
        withCredentials: true
        }).toPromise().then(
            res => {
               const response = res.body;
               if (response['IsSuccess']) {
                    const userObject = response['Data']['user'];
                    const cameralla_id = userObject['id'];
                    const wp_id = userObject['wp_id'];
                    const accessToken = userObject['access_token'];

                    this.setLocalUserObject({id: cameralla_id, wp_id: wp_id, accessToken: accessToken});

                    return Promise.resolve(response);
                }

                return Promise.resolve(false);
            }
        );
    }

    public logout() {
        this.localStorage.removeItem(this.dataKey);

        return Promise.resolve(true);
    }

    public isAuthenticated() {
        return !!this.localStorage.getItem(this.dataKey);
    }

    public getLocalUserInfo() {
        return this.getLocalUserObject();
    }
}
